import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormDataSetComponent } from './form-data-set.component';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  FieldDateModule,
  FieldDateRangeModule,
  FieldDateTimeModule, FieldEmailModule, FieldImageModule, FieldMapDrawModule,
  FieldNumberModule, FieldPasswordModule,
  FieldSelectModule,
  FieldTextModule
} from '../inputs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { FormDataSetRenderErrorPipe } from './form-data-set-render-error.pipe';
import { FieldSelectMultipleModule } from '../inputs';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FieldExpressionModule } from '../inputs/field-expression';
import {FormFieldShowPipe} from "./form-field-hide.pipe";
import { FieldPhoneModule } from '../inputs/field-phone';

@NgModule({
  declarations: [
    FormDataSetComponent,
    FormDataSetRenderErrorPipe,
  ],
  exports: [
    FormDataSetComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatDatepickerModule,
    FieldSelectModule,
    FieldTextModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDividerModule,
    FieldNumberModule,
    FieldSelectMultipleModule,
    FieldDateRangeModule,
    FieldDateTimeModule,
    FileUploadModule,
    FieldImageModule,
    FieldExpressionModule,
    FieldMapDrawModule,
    FormFieldShowPipe,
    FieldDateModule,
    FieldPhoneModule,
    FieldPasswordModule,
    FieldEmailModule
  ]
})
export class FormDataSetModule { }
